import { initMonitoring } from '~/utils/monitoring';

interface DVGConfig {
  pluginUrl: string;
  pluginVersion: string;
  apiBaseUrl: string;
  appsignalKey?: string;
}

class DVGPlugin {
  constructor() {
    initMonitoring();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.DVGBookingPlugin = new DVGPlugin();
});

declare global {
  interface Window {
    DVGBookingPlugin: DVGPlugin;
    DVGBookingConfig: DVGConfig;
    dataLayer: Record<string, string>[];
  }
}

export {};
